import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../../../../@fury/shared/material-components.module';
import { ScrollbarModule } from '../../../../@fury/shared/scrollbar/scrollbar.module';
import { ViewerComponent } from './viewer.component';
import { LoadingOverlayModule } from '../../../../@fury/shared/loading-overlay/loading-overlay.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuryAlertBoxModule } from '../../../../@fury/shared/alert-box/alert-box.module';
import { MtxDatetimepickerModule } from '@ng-matero/extensions/datetimepicker';
import { LightboxModule } from 'ng-gallery/lightbox';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { RouterModule } from '@angular/router';
import { QuillModule } from 'ngx-quill';
import { PageHeaderButtonsModule } from '../../../../@fury/shared/page-header-buttons/page-header-buttons.module';
import { TableFiltersModule } from '../../../../@fury/shared/table-filters/table-filters/table-filters.module';
import { MatChipsModule } from '@angular/material/chips';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { NgxLoadingControlModule } from '@runette/ngx-leaflet-loading';
import { NgxMaskModule } from 'ngx-mask';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FurySharedModule } from '../../../../@fury/fury-shared.module';
import { AttachmentModule } from '../../../../@fury/shared/attachment/attachment.module';
import { LeafletMapService } from '../../../services/base/leaflet-map.service';
import { PipesModule } from '../../../../@fury/utils/pipes.module';
import { BackdropModule } from '../../../../@fury/shared/backdrop/backdrop.module';
import { IndexModule } from '../../tasks/index/index.module';
import { MatPaginationGoToPageDirective } from '../../../../@fury/shared/mat-pagination-go-to-page/mat-pagination-go-to-page.directive';
import { OverviewService } from '../../../services/overview/overview.service';
import { TileService } from '../../../services/routering/tile.service';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ScrollbarModule,
    LoadingOverlayModule,
    ReactiveFormsModule,
    FuryAlertBoxModule,
    MtxDatetimepickerModule,
    LightboxModule,
    MaterialFileInputModule,
    RouterModule,
    QuillModule,
    PageHeaderButtonsModule,
    FormsModule,
    TableFiltersModule,
    MatChipsModule,
    LeafletModule,
    NgxLoadingControlModule,
    NgxMaskModule,
    NgxMatSelectSearchModule,
    FurySharedModule,
    AttachmentModule,
    PipesModule,
    BackdropModule,
    IndexModule,
    MatPaginationGoToPageDirective,
  ],
  declarations: [
    ViewerComponent,
  ],
  exports: [
    ViewerComponent,
  ],
  providers: [
    LeafletMapService,
    OverviewService,
    TileService,
  ]
})
export class ViewerModule {
}
